import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'
//import request from './utils/httpRequest';





const app = createApp(App)
app.use(store).use(router).mount('#app');

//app.config.globalProperties.$request = request;
